module.exports = __webpack_public_path__ + "img/onca-vega-isotipo-240.6895ad01.svg";